<template>
  <ion-content class="ion-padding">
    <ion-button size="small" @click="closePopover('open_product')">
        <ion-icon :icon="eyeOutline"></ion-icon> Open
    </ion-button>  
    <br>
    <ion-button size="small" @click="closePopover('add_to_visit')">
        Add to visit
    </ion-button>  
    <br>
    <ion-button size="small" @click="closePopover('cancelled')" >
        Cancel
    </ion-button>
  </ion-content>
</template>

<script>
import { IonContent, IonButton, popoverController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { eyeOutline } from "ionicons/icons";

export default defineComponent({
  name: 'Popover',
  components: { IonContent, IonButton },
  data(){
      return {
          popoverController:popoverController,
          eyeOutline
      }
  },
  
  methods:{
      closePopover(action){
          this.popoverController.dismiss(action);
      }
  }

});
</script>